import * as AnimatedCarousel from '@components/animated-carousel'
import Image from 'next/image'
import { BlockCall } from 'types/block-call'
import { HomeLinkButton } from '../components/home-link-button'
import { useEffect, useState } from 'react'

type Props = {
  data: Array<BlockCall>
}

export const SystemsSoldSection = ({ data }: Props) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [size, setSize] = useState(4)

  // Proteção contra data undefined ou vazio
  if (!data || data.length === 0) {
    return null
  }

  const nextSlide = () => {
    setCurrentIndex(prev => (prev + 1) % data.length)
  }
  // determine size responsively (SSR-safe)
  useEffect(() => {
    const update = () => {
      if (typeof window === 'undefined') return
      const w = window.innerWidth
      if (w >= 1024) setSize(4)
      else if (w >= 400) setSize(2)
      else setSize(1)
    }

    update()
    window.addEventListener('resize', update)
    return () => window.removeEventListener('resize', update)
  }, [])
  const prevSlide = () => {
    setCurrentIndex(prev => (prev - 1 + data.length) % data.length)
  }
  return (
    <AnimatedCarousel.Root>
      <AnimatedCarousel.Header
        transition={{
          duration: 0.7,
          delay: 0.5
        }}
      >
        <h2 className="inline-block text-black text-[1.75rem] tracking-[-1px] font-bold text-center md:text-3xl md:tracking-[-0.5px] 1.5xl:text-[2.1875rem] 1.5xl:tracking-[-0.5px] py-2">
          Cursos de Energia Solar
        </h2>
        <p className="text-xs text-v2-eerie-black text-center md:text-base py-2">
          Mais de 20.000 alunos qualificados, conheça os <br />
          melhores cursos de energia solar do Brasil
        </p>
      </AnimatedCarousel.Header>

      <AnimatedCarousel.Section
        transition={{
          duration: 0.7,
          delay: 1.4
        }}
      >
        {/* <div className="relative w-11 h-3 mt-3 md:w-[3.5956rem] md:h-5 1.5xl:w-[4.6718rem] 1.5xl:h-6 1.5xl:mt-6">
          <Image
            fill
            quality={100}
            alt="logo google"
            src="/google.svg"
            className="object-contain"
          />
        </div>

        <div className="relative flex items-center gap-1 ml-1 mb-16 md:ml-0 md:mb-6 lg:gap-0 lg:mb-7 1.5xl:mb-8">
          <p className="absolute -left-3 -top-0.5 font-semibold text-[0.5rem] md:text-[0.625rem] md:top-0 lg:-left-3 1.5xl:text-[0.8625rem] 1.5xl:-left-4 1.5xl:top-0.5">
            4.9
          </p>
          <div className="relative w-12 h-2 mt-1 md:w-[4.31rem] md:h-2.5 1.5xl:w-[5.5625rem] 1.5xl:h-[0.8125rem]">
            <Image
              fill
              quality={100}
              alt="nota em formado de estrelas preenchidas"
              src="/stars.svg"
              className="object-contain"
            />
          </div>
        </div> */}
      </AnimatedCarousel.Section>
      <div
        className={`relative w-full h-96  md:h-[600px]  rounded-xl overflow-hidden shadow-lg my-6 md:hidden`}
      >
        <Image
          alt={data[currentIndex]?.imageAlt || 'Nossos Cursos de Energia Solar'}
          src={
            data[currentIndex]?.imageUrl ||
            'https://www.portalsolar.com.br/assets/logo-header.svg'
          }
          fill
          className="object-cover transition-transform duration-300 rounded-lg"
          loading="lazy"
        />
        {/* Overlay com informações */}
        <div className={`absolute inset-0`}>
          <div
            className={`flex flex-col  absolute rounded-lg bottom-0 h-full w-full  p-4
                 ${
                   size > 2
                     ? ' items-start justify-center left-0 pl-12 bg-gradient-to-r from-black/60 rounded-lg to-transparent'
                     : 'items-center justify-end bg-gradient-to-t from-black/60 to-transparent pb-5 '
                 }  text-white`}
          >
            <h3 className="font-bold text-5xl mb-2 text-right">
              {data[currentIndex]?.title || ''}
            </h3>
            <span className="w-16 bg-[#7be500] h-1"></span>
            <p className="py-2 text-xl font-medium opacity-90">
              {data[currentIndex]?.description || ''}
            </p>
            {data[currentIndex]?.buttonLink !== '' && (
              <a href={data[currentIndex]?.buttonLink || '#'}>
                <button className="mt-2 px-4 py-2 bg-[#63F14B] text-black rounded-full flex justify-center items-center">
                  <span className="pt-[2px] pe-2">►</span>{' '}
                  {data[currentIndex]?.buttonText || 'Veja a Prévia'}
                </button>
              </a>
            )}
          </div>
        </div>

        {/* Setas de navegação */}
        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-colors duration-200"
          aria-label="Slide anterior"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-colors duration-200"
          aria-label="Próximo slide"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>
      {/* Indicadores de posição */}

      <div className=" bottom-0 -mt-2 left-1/2 flex md:hidden space-x-2 justify-center w-full">
        {data.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-3 h-3 rounded-full transition-colors duration-200 ${
              index === currentIndex
                ? 'w-7 bg-gray-400'
                : 'hover:bg-gray-400 bg-gray-200 hover:w-7'
            }`}
            aria-label={`Ir para slide2 ${index + 1}`}
          />
        ))}
      </div>
      {/* Versão desktop - mantém o primeiro item */}
      <div
        className={`relative w-full ${
          size === 1 ? 'h-[400px]' : size === 2 ? 'h-[600px]' : 'h-[700px]'
        } overflow-hidden shadow-lg my-6 hidden md:block`}
      >
        <Image
          alt={data[0]?.imageAlt}
          src={data[0]?.imageUrl}
          fill
          className="object-cover transition-transform duration-300 rounded-xl"
          loading="lazy"
        />
        {/* Overlay com informações */}
        <div
          className={`absolute inset-0  ${
            size === 1
              ? 'items-center'
              : size === 2
              ? 'items-center'
              : 'items-end'
          } flex items-end`}
        >
          <div
            className={`flex flex-col w-2/5  ${
              size === 1
                ? 'items-center'
                : 'items-start left-0 pl-12 bg-gradient-to-r from-black/60 to-transparent'
            }  justify-center absolute bottom-0 h-full  rounded-xl p-4 text-white pl-16`}
          >
            <h3 className="font-bold text-5xl mb-2 text-right">
              {data[0]?.title || ''}
            </h3>
            <span className="w-16 bg-[#7be500] h-1"></span>
            <p className="py-2 text-xl font-medium opacity-90">
              {data[0]?.description || ''}
            </p>
            {data[0]?.buttonLink !== '' && (
              <a href={data[0]?.buttonLink || '#'}>
                <button className="mt-2 px-4 py-2 bg-[#63F14B] text-black rounded-full flex justify-center items-center">
                  <span className="pt-[2px] pe-2">►</span>{' '}
                  {data[0]?.buttonText || 'Veja a Prévia'}
                </button>
              </a>
            )}
          </div>
        </div>
      </div>

      <AnimatedCarousel.Section
        transition={{
          duration: 1,
          delay: 1
        }}
        className="w-full relative"
      >
        <AnimatedCarousel.BlockCallsCarousel data={data.slice(1)} />
      </AnimatedCarousel.Section>

      {/* <AnimatedCarousel.Section
        transition={{
          duration: 0.7,
          delay: 1.4
        }}
        className="w-full relative px-4 hidden md:block"
      >
        <div className="w-full flex justify-center">
          <HomeLinkButton
            href="/curso-de-energia-solar"
            className="max-w-[20.875rem] mt-32 md:mt-6 xl:mt-5 2xl:mt-10 1.5xl:mt-11"
          >
            CURSO DE ENERGIA SOLAR
          </HomeLinkButton>
        </div> 
      </AnimatedCarousel.Section> */}
    </AnimatedCarousel.Root>
  )
}
